import { Aperture, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/[0.07] bg-[#0A0A0C]">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 px-4 py-12 sm:flex-row sm:px-8 lg:px-16">
        <div className="flex items-center gap-2.5">
          <span className="flex h-8 w-8 items-center justify-center rounded-full border border-[#D4AF37]/50 bg-[#D4AF37]/10">
            <Aperture size={15} className="text-[#E2C275]" />
          </span>
          <span className="font-display text-base font-bold tracking-wide text-zinc-50">
            COASTAL <span className="text-[#D4AF37]">CHOICE</span>
            <span className="ml-2 font-tech align-middle text-[8px] font-medium tracking-[0.35em] text-zinc-500">
              SOLUTIONS
            </span>
          </span>
        </div>

        <p className="font-tech text-[11px] uppercase tracking-[0.25em] text-zinc-600">
          Real estate photography · Astoria, Oregon
        </p>

        <div className="flex items-center gap-3">
          <a
            href="mailto:coastalchoicesolutions@gmail.com"
            data-testid="footer-email-link"
            className="rounded-full border border-white/10 p-2.5 text-zinc-400 transition-colors hover:border-[#D4AF37]/60 hover:text-[#E2C275]"
            aria-label="Email"
          >
            <Mail size={15} />
          </a>
        </div>
      </div>
      <div className="border-t border-white/[0.05] py-5 text-center text-[11px] text-zinc-600">
        © {new Date().getFullYear()} Coastal Choice Solutions · Interior, exterior & aerial drone photography
      </div>
    </footer>
  );
};

export default Footer;
